// interface User {
//   first_name?: string
//   phone?: string
//   full_name?: string
// }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function (string: string, user: any, targetName?: string, customReplace?: string): string {
  let new_string = string.replace(/{name}/g, user.first_name || '')
  new_string = new_string.replace(/{phone}/g, user.phone || '')
  new_string = new_string.replace(/{full_name}/g, user.full_name || '')
  if (targetName) {
    new_string = new_string.replace(/{target_name}/g, targetName || '')
  }
  if (customReplace) {
    new_string = new_string.replace(/{custom}/g, customReplace || '')
  }
  return new_string
}
